export default __webpack_public_path__ + "static/media/product-12.d4178275.webp";